import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import * as OptionController from '../../../controllers/OptionsController';
import { GlobalState } from '../../../states/global-state';
import { showAlert } from '../../../utils';

type CustomSelectProps = {
  name: string;
  label: string;
  options?: [];
  value?: string;
  validator?: string;
  optionCategory?: string;
  remoteOption?: boolean;
  optionGetter?: string;
};

const CustomSelect = (props: CustomSelectProps) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (props.remoteOption) {
      OptionController[props.optionGetter]({
        category: props.optionCategory,
      })
        .then(res => {
          // console.log(27, res);
          setOptions(
            res.map((item, index) => {
              return { value: item.code, display: item.value, id: index };
            })
          );
        })
        .catch(err => {
          showAlert({
            title: 'Error',
            text: err.message,
            icon: 'error',
          });
        });
    } else if (props.options) {
      setOptions(props.options);
    }
  }, []);

  return (
    <div class="form-floating mb-3 form-group">
      <select
        class="form-select input"
        id={props.name}
        name={props.name}
        value={props.value}
        data-validator={props.validator || ''}
      >
        {options.map(item => {
          if (props.value == item.value) {
            return (
              <option selected value={item.value} key={item.key}>
                {item.display}
              </option>
            );
          }
          return (
            <option value={item.value} key={item.key}>
              {item.display}
            </option>
          );
        })}
      </select>
      <label for={props.name}>{props.label}</label>
    </div>
  );
};

export default CustomSelect;
